var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#F34F66",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4767 25.6226C29.9949 24.2809 32.3644 23.0004 36.0002 23.0004C40.0215 23.0004 42.676 24.5831 44.3449 26.4309C46.083 28.3553 46.728 30.5343 46.728 31.585C46.728 32.5791 47.5339 33.385 48.528 33.385C49.589 33.385 51.1955 33.7935 52.4988 34.7752C53.7319 35.704 54.7002 37.1398 54.7002 39.3735C54.7002 42.7002 53.07 44.4997 51.1864 45.4691C50.3025 45.924 49.9547 47.0093 50.4096 47.8932C50.8645 48.7772 51.9498 49.125 52.8338 48.67C55.7588 47.1647 58.3002 44.2172 58.3002 39.3735C58.3002 35.8956 56.706 33.4372 54.6648 31.8996C53.2433 30.8289 51.6093 30.2027 50.1387 29.9368C49.7427 28.0899 48.7196 25.9035 47.0166 24.018C44.6994 21.4523 41.09 19.4004 36.0002 19.4004C31.416 19.4004 28.2141 21.0502 26.0926 22.9252C25.3477 23.5835 25.2776 24.7211 25.9359 25.4659C26.5943 26.2108 27.7318 26.281 28.4767 25.6226ZM22.9679 30.2137C20.3783 31.2293 17.3002 33.7464 17.3002 38.335C17.3002 41.9012 18.7196 43.8003 20.3445 44.8868C22.0822 46.0487 24.2523 46.4004 25.7502 46.4004H39.1546L22.9679 30.2137ZM42.7546 50.0004H25.7502C23.8314 50.0004 20.8765 49.5732 18.3434 47.8794C15.6975 46.1101 13.7002 43.0765 13.7002 38.335C13.7002 32.618 17.0845 29.2116 20.2654 27.5112L17.773 25.0188C17.07 24.3158 17.07 23.1761 17.773 22.4732C18.4759 21.7702 19.6156 21.7702 20.3186 22.4732L47.4715 49.6261C48.1744 50.329 48.1744 51.4687 47.4715 52.1717C46.7685 52.8746 45.6288 52.8746 44.9259 52.1717L42.7546 50.0004Z",
    fill: "#F5314D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.e402b2a7030b88c3f1b7d62ce1a1f441.svg";
export { ForwardRef as ReactComponent };